import React, { useState } from "react";
import { scheduleData } from "./scheduleData";
import "./program.css";

const ConferenceSchedule = () => {
  // Track the currently selected session (with its color) for modal popup
  const [selectedSession, setSelectedSession] = useState(null);
  const { highlight, days } = scheduleData;

  // Define the same colors as in your CSS alternate background colors
  const sessionColors = [
    "#e3f2fd", // light blue
    "#fce4ec", // light pink
    "#e8f5e9", // light green
    "#fff3e0", // light orange
    "#ede7f6", // light purple
    "#f3e5f5", // light violet
  ];

  const handleOpenSession = (session, color) => {
    // Store the session along with the computed color
    setSelectedSession({ ...session, color });
  };

  const handleCloseModal = () => {
    setSelectedSession(null);
  };

  return (
    <div className="conference-schedule">
      <div className="conference-schedule-container">
        <div className="conference-highlight">
          <h1 className="main-h1">Program Schedule</h1>
          <p>
            <strong>Dates:</strong> {highlight.duration}
          </p>
          <p>
            <strong>Theme:</strong> {highlight.theme}
          </p>
          {highlight.description && <p>{highlight.description}</p>}
        </div>

        {/* Render sessions grouped by day */}
        <div className="schedule-days">
          {days.map((day, dayIdx) => (
            <div className="day-wrapper" key={dayIdx}>
              <h2 className="day-date">{day.date}</h2>
              <div className="day-sessions">
                {day.sessions.map((session, idx) => {
                  // Compute background color based on index
                  const bgColor = sessionColors[idx % sessionColors.length];
                  return (
                    <div
                      key={idx}
                      className="session-card"
                      style={{ backgroundColor: bgColor }}
                    >
                      <div className="session-header">
                        <h3 className="session-title">{session.title}</h3>
                        {session.department && (
                          <p className="session-department">
                            {session.department}
                          </p>
                        )}
                        <p className="session-date-time">
                          {session.date} | {session.sessionTime}
                        </p>
                      </div>
                      <button
                        className="view-details-btn"
                        onClick={() => handleOpenSession(session, bgColor)}
                      >
                        View More Details
                      </button>
                    </div>
                  );
                })}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Modal Popup for session details */}
      {selectedSession && (
        <div className="modal-overlay" onClick={handleCloseModal} >
          <div
            className="modal-content"
            onClick={(e) => e.stopPropagation()} // prevent modal close on inner click
            style={{ backgroundColor: selectedSession.color }}
          >
            <button className="modal-close" onClick={handleCloseModal}>
              &times;
            </button>
            <div
              className="modal-header"
            >
              <h3>{selectedSession.title}</h3>
              {selectedSession.department && (
                <p className="session-department">
                  <strong>Department:</strong> {selectedSession.department}
                </p>
              )}
              <p className="session-date-time">
                <strong>Date:</strong> {selectedSession.date} |{" "}
                <strong>Time:</strong> {selectedSession.sessionTime}
              </p>
            </div>
            <div className="modal-body">
              {selectedSession.venue && (
                <p>
                  <strong>Venue:</strong> {selectedSession.venue}
                </p>
              )}
              {selectedSession.chair && (
                <p>
                  <strong>Chair:</strong> {selectedSession.chair}
                </p>
              )}
              {selectedSession.coChair && (
                <p>
                  <strong>Co-Chair:</strong> {selectedSession.coChair}
                </p>
              )}
              {selectedSession.moderator && (
                <p>
                  <strong>Moderator:</strong> {selectedSession.moderator}
                </p>
              )}
              {selectedSession.program && (
                <div className="program-details">
                  <h4>Session Talks</h4>
                  {selectedSession.program.map((talk, idx) => (
                    <div key={idx} className="talk-item">
                      <p>
                        <strong>{talk.time}</strong> -{" "}
                        <em>{talk.talkTitle}</em>{" "}
                        {talk.speaker && <>by <strong>{talk.speaker}</strong></>}
                      </p>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ConferenceSchedule;
